// extracted by mini-css-extract-plugin
export default {"Products_description":"ProductCardFooter_Products_description__gQhqK"};